import styled from "@emotion/styled";
import { kafSystemWidth, systemWidth } from "@kaltura/mediaspace-shared-styled";
import { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";
import { CategoryHeaderBasicMetadata, CategoryHeaderBasicMetadataProps } from "./CategoryHeaderBasicMetadata";

export const StyledLeanHeaderContainer = styled("div")<{ isKaf?: boolean }>(({ theme, isKaf }) => ({
    "&": isKaf ? kafSystemWidth({ theme }) : systemWidth({ theme }),
}));

export function GalleryHeader(props: Omit<CategoryHeaderBasicMetadataProps, "isChannel">) {
    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    return (
        <StyledLeanHeaderContainer className={"kms-ds-gallery-page-header"} isKaf={isKaf}>
            <CategoryHeaderBasicMetadata {...props} isChannel={false} />
        </StyledLeanHeaderContainer>
    );
}
